import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import HomePage from "@/pages/HomePage";
import ProfilePicker from "@/pages/ProfilePicker";
import NewMatchPage from "@/pages/NewMatchPage";
import TournamentsPage from "@/pages/TournamentsPage";
import TournamentDetailPage from "@/pages/TournamentDetailPage";
import GoalkeeperMenu from "@/pages/GoalkeeperMenu";
import SessionRegister from "@/pages/SessionRegister";
import EvaluateSelector from "@/pages/EvaluateSelector";
import EvaluateView from "@/pages/EvaluateView";
import ShareView from "@/pages/ShareView";
import GatePage from "@/pages/GatePage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";
import JournalPage from "@/pages/JournalPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 font-display uppercase tracking-widest">
        Laddar…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/gate" replace state={{ from: location.pathname }} />;
  }
  return children;
}

function App() {
  return (
    <div className="App grain">
      <div className="arena-bg" />
      <BrowserRouter>
        <AuthProvider>
          <ErrorBoundary>
            <Routes>
            {/* Public */}
            <Route path="/gate" element={<GatePage />} />
            <Route path="/share/:token" element={<ShareView />} />

            {/* Protected app */}
            <Route path="/" element={<Protected><HomePage /></Protected>} />
            <Route path="/profiles" element={<Protected><ProfilePicker /></Protected>} />
            <Route path="/new-match" element={<Protected><NewMatchPage /></Protected>} />
            <Route path="/tournaments" element={<Protected><TournamentsPage /></Protected>} />
            <Route path="/tournaments/:tournamentId" element={<Protected><TournamentDetailPage /></Protected>} />
            <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
            <Route path="/gk/:gkId/journal" element={<Protected><JournalPage /></Protected>} />
            <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/gk/:gkId" element={<Protected><GoalkeeperMenu /></Protected>} />
            <Route
              path="/gk/:gkId/session/:sessId/register"
              element={<Protected><SessionRegister /></Protected>}
            />
            <Route path="/gk/:gkId/evaluate" element={<Protected><EvaluateSelector /></Protected>} />
            <Route
              path="/gk/:gkId/evaluate/session/:sessId"
              element={<Protected><EvaluateView mode="session" /></Protected>}
            />
            <Route
              path="/gk/:gkId/evaluate/period"
              element={<Protected><EvaluateView mode="period" /></Protected>}
            />
            <Route
              path="/gk/:gkId/evaluate/all"
              element={<Protected><EvaluateView mode="all" /></Protected>}
            />
            <Route
              path="/gk/:gkId/evaluate/tournament/:tournamentId"
              element={<Protected><EvaluateView mode="tournament" /></Protected>}
            />
            <Route path="*" element={<Navigate to="/gate" replace />} />
          </Routes>
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid #27272A",
            color: "#ffffff",
          },
        }}
      />
    </div>
  );
}

export default App;
